var _defs, _path, _path2, _ellipse, _path3, _path4, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMorebutton01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-185{stroke:#fff;}.cls-185,.cls-184{stroke-miterlimit:10;stroke-width:2.11px;}.cls-184{fill:#fff;stroke:#000;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M368.74,335.55c-17-18.27-35.31-36.59-54.9-54.72q-5.2-4.83-10.53-9.61-10.74-9.71-21.94-19.27-6.14-5.25-12.29-10.35-5.5-4.59-11-9c-20.63-16.69-41.3-32.18-61.76-46.36-6.89-4.77-5.14-15.31,2.89-17.18,23.35-5.42,60,6.44,96.48,31.67q6.82,4.71,13.59,10,4.5,3.54,8.95,7.34c3.28,2.81,6.48,5.67,9.56,8.56q6.3,5.9,12,11.93c31.27,33.15,48.46,68.57,45.07,92.32C383.73,338.58,374.13,341.36,368.74,335.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M303.31,271.22c-18.47,18.23-38,22.69-44.45,17.17s-5.07-25.64,10.22-46.79q-5.5-4.59-11-9c-18.65,25.5-22.59,54.13-8.23,66.41s41.78,4,64-18.13Q308.64,276,303.31,271.22Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-185",
    cx: 311.97,
    cy: 226.28,
    rx: 18.77,
    ry: 75.92,
    transform: "translate(-62.76 316.33) rotate(-49.47)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M294.85,236.05c-24.7,3.36-50.24,7.82-76.34,13.41q-6.94,1.47-13.92,3.08-14.11,3.19-28.38,6.85-7.83,2-15.54,4.09-6.91,1.88-13.75,3.83c-25.52,7.26-50.08,15.25-73.46,23.83C65.6,294,58,286.52,61.08,278.89c9-22.22,39.8-45.38,81.42-60.69q7.77-2.87,16-5.33,5.47-1.65,11.15-3.1c4.19-1.07,8.37-2,12.5-2.9,5.63-1.17,11.2-2.15,16.67-2.93,45.1-6.51,84-.18,101.44,16.26C306,225.53,302.7,235,294.85,236.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M204.59,252.54c4.28,25.6-3.32,44.14-11.53,46.24s-23.89-10.61-32.39-35.3q-6.91,1.88-13.75,3.83c10.12,29.92,31.27,49.62,49.58,44.94s27.33-31.86,22-62.79Q211.57,250.93,204.59,252.54Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-184",
    cx: 172.82,
    cy: 219.6,
    rx: 75.92,
    ry: 18.77,
    transform: "translate(-48.99 49.63) rotate(-14.33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorebutton01);
export default __webpack_public_path__ + "static/media/MORE BUTTON-01.1e6504d7706fc22e1cc9c92c6ca0f108.svg";
export { ForwardRef as ReactComponent };